import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/confirm',
    name: 'confirm',
    component: () => import(/* webpackChunkName: "other" */ '../views/other/confirm.vue'),
    meta: { title: '弘策科技—面试邀请函' },
  },
  {
    path: '/checkLogin',
    name: 'checkLogin',
    component: () => import(/* webpackChunkName: "other" */ '../views/userRegistration/index.vue'),
    meta: { title: '弘策科技应聘登记表' },
  },
  {
    path: '/baseInfo',
    name: 'base',
    component: () => import(/* webpackChunkName: "user" */ '../views/userRegistration/baseInfo.vue'),
    meta: { title: '弘策科技电子信息档案' },
  },
  {
    path: '/education',
    name: 'education',
    component: () => import(/* webpackChunkName: "user" */ '../views/userRegistration/education.vue'),
    meta: { title: '弘策科技电子信息档案' },
  },
  {
    path: '/workExperience',
    name: 'workExperience',
    component: () => import(/* webpackChunkName: "user" */ '../views/userRegistration/workExperience.vue'),
    meta: { title: '弘策科技电子信息档案' },
  },
  {
    path: '/signature',
    name: 'signature',
    component: () => import(/* webpackChunkName: "user" */ '../views/userRegistration/signature.vue'),
    meta: { title: '弘策科技电子信息档案' },
  },
  {
    path: '/fillOver',
    name: 'fillOver',
    component: () => import(/* webpackChunkName: "user" */ '../views/userRegistration/fillOver.vue'),
    meta: { title: '弘策科技-逻辑测试题' },
  },
  {
    path: '/fillOver2',
    name: 'fillOver2',
    component: () => import(/* webpackChunkName: "user" */ '../views/userRegistration/fillOver2.vue'),
    meta: { title: '弘策科技电子信息档案' },
  },
  {
    path: '/interviewEvaluation',
    name: 'interviewEvaluation',
    component: () => import(/* webpackChunkName: "user" */ '../views/evaluation/interview_evaluation.vue'),
    meta: { title: '弘策科技-面试评估表' },
  },
  {
    path: '/evaluation',
    name: 'evaluation',
    component: () => import(/* webpackChunkName: "user" */ '../views/evaluation/evaluation.vue'),
    meta: { title: '弘策科技-面试评估表' },
  },
  {
    path: '/induction_confirm',
    name: 'induction_confirm',
    component: () => import(/* webpackChunkName: "user" */ '../views/induction/induction_confirm.vue'),
    meta: { title: '欢迎加入弘策科技' },
  },
  {
    path: '/induction_value',
    name: 'induction_value',
    component: () => import(/* webpackChunkName: "user" */ '../views/induction/induction_value.vue'),
    meta: { title: '欢迎加入弘策科技' },
  },
  {
    path: '/submit_over',
    name: 'submit_over',
    component: () => import(/* webpackChunkName: "user" */ '../views/induction/comp/submit_over.vue'),
    meta: { title: '欢迎加入弘策科技' },
  },
  {
    path: '/welcome',
    name: 'welcome',
    component: () => import(/* webpackChunkName: "user" */ '../views/component/welcome.vue'),
    meta: { title: 'welcome' },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch((err) => err);
};
export default router;
